import React from 'react';
import classNames from 'classnames';

const FormTextArea = ({small, value, onChange, disabled, className, ...props}) => (
    <>
        <textarea {...props} disabled={disabled} className={classNames(className, 'form-control', {'form-control-sm': small})} value={value} onChange={event => onChange(event.target.value)}/>
    </>
);

export default FormTextArea;